import { Stack } from '@mui/joy';

import { InvalidAccess } from '../../../layout/mobile/InvalidAccess';

const MNotFoundPage = () => {
  return (
    <Stack height={'100vh'} bgcolor={'#FFF'} overflow={'auto'}>
      <InvalidAccess />
    </Stack>
  );
};

export default MNotFoundPage;
